import { encounterCreatureField, scalarLayerSlot } from '../../shared/array-types';
import { readInventoryHidden } from '../inventory/flag-adjust';

type Row = Record<string, unknown>;
export interface MarkerRosterViewer { gm: boolean; preview: boolean; private: boolean }
const record = (value: unknown): Row => value !== null && typeof value === 'object' ? value as Row : {};

/** The same stored Hidden mark drives inventory controls and marker rosters. */
export function targetIsHidden(row: Row): boolean {
    return readInventoryHidden(row, '47667406-1B72-9D60-310B-D8CF6BFE397D') === 1;
}

export function markerRosterCreatureVisible(row: Row, viewer: MarkerRosterViewer): boolean {
    const ec = record(row.encounter_creatures);
    if (Number(encounterCreatureField(ec, 'encounter_creature_dead') ?? 0) !== 0) return false;
    if (Number(encounterCreatureField(ec, 'encounter_creature_private') ?? 0) !== 0 && !viewer.private) return false;
    if (viewer.preview || !targetIsHidden(row)) return true;
    return viewer.gm || scalarLayerSlot(record(row.player_characters).player_name) !== '';
}
